import type { GetCandidateRegion } from "./types";

export const getCandidateRegion: GetCandidateRegion = ({
  side,
  pageWidth,
  pageHeight,
  bbox,
  margin,
  legendWidth,
  legendHeight,
}) => {
  switch (side) {
    case "right":
      return {
        x: bbox.maxX + margin,
        y: margin,
        regionWidth: pageWidth - bbox.maxX - 2 * margin,
        regionHeight: pageHeight - 2 * margin,
      };
    case "below":
      return {
        x: pageWidth - legendWidth - margin,
        y: bbox.maxY + margin,
        regionWidth: pageWidth - 2 * margin,
        regionHeight: pageHeight - bbox.maxY - 2 * margin,
      };
    case "left":
      return {
        x: margin,
        y: margin,
        regionWidth: bbox.minX - 2 * margin,
        regionHeight: pageHeight - 2 * margin,
      };
    case "above":
      return {
        x: pageWidth - legendWidth - margin,
        y: bbox.minY - margin - legendHeight,
        regionWidth: pageWidth - 2 * margin,
        regionHeight: bbox.minY - 2 * margin,
      };
  }
};
